import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import Error404 from './pages/errors/Error404'
import LoginLayout from './layouts/loginLayouts/LoginLayout'
import LoginAdminLayout from './layouts/loginAdminLayouts/LoginAdminLayout'
import PortalLayout from './layouts/portalLayouts/PortalLayout'
import MainLayouts from './layouts/systemLayouts/MainLayout'
import Dashboard from './pages/Home'
import Login from './pages/login/Login'
import LoginAdmin from './pages/loginadmin/LoginAdmin'
import Systems from './pages/systems/Systems'
import Main from './pages/main/Main'
import News from './pages/news/News'
import NewsDetail from './pages/newsdetail/NewsDetail'
import Downloadfile from './pages/downloadfile/DownloadFile'
import Forgotpassword from './pages/forgotpassword/Forgotpassword'
import Forgotpasswordchange from './pages/forgotpassword/Changepassword'
import ChangePassword from './pages/changepassword/ChangePassword'
import CloseWebComponent from './components/closeweb/CloseWeb'
import useCloseWeb from './components/closeweb/useCloseWeb'
import useCacheClean from './hooks/useCacheClean'
import { Spinners } from 'pda-components'
import './App.less'

function App() {
  useCacheClean()
  const { openWeb, configData, configLoading } = useCloseWeb()

  useEffect(() => {
    if (localStorage.getItem('debug') === '2') {
      document.body.classList.add('debug-mode')
    } else {
      document.body.classList.remove('debug-mode')
    }
  }, [])

  if (configLoading) {
    return <Spinners />
  }

  return (
    <Routes>
      {openWeb === 0 ? (
        <Route element={<LoginLayout />}>
          <Route path="*" element={<CloseWebComponent configData={configData} />} />
        </Route>
      ) : (
        <>
          <Route element={<PortalLayout />}>
            <Route index element={<News />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/news" element={<News />} />
            <Route path="/news-detail" element={<NewsDetail />} />
            <Route path="/downloadfile" element={<Downloadfile />} />
            <Route path="*" element={<Error404 />} />
          </Route>
          <Route element={<LoginAdminLayout configData={configData} />}>
            <Route path="/login/admin" element={<LoginAdmin />} />
          </Route>
          <Route element={<LoginLayout configData={configData} />}>
            <Route path="/login" element={<Login />} />
            <Route path="/authen" element={<Systems />} />
            <Route path="/forgotpassword" element={<Forgotpassword />} />
            {/* ลิงก์สำหรับเปลี่ยนรหัสผ่านจากอีเมล */}
            <Route path="/forgotpassword/change/:resettoken" element={<Forgotpasswordchange />} />
            <Route path="/authen/changepassword" element={<ChangePassword />} />
          </Route>
          <Route element={<MainLayouts />}>
            <Route path="/authen/main" element={<Main />} />
          </Route>
        </>
      )}
    </Routes>
  )
}

export default App
